





















import LbKeyboard from './lb-keyboard.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'lb-verification-code',
  components: {
    LbKeyboard
  }
})
export default class extends Vue {
  private verCodeList = [{ id: 1, num: '' }, { id: 2, num: '' }, { id: 3, num: '' }, { id: 4, num: '' }, { id: 5, num: '' }, { id: 6, num: '' }];
  private codeIndex = 0;
  private codeFocus = true;
  private isError = false;
  private isSuccess = false;
  private isShowVerificationCodeKeyboard: boolean = true

  created() {
    window.addEventListener('keydown', this.keyDownListener)
    window.addEventListener('focus', this.focusListener)
    window.addEventListener('blur', this.blurListener)
  }

  private keyDownListener(e: any) {
    if (this.codeIndex < 6) {
      if (e.key === '1' || e.key === '2' || e.key === '3' || e.key === '4' || e.key === '5' || e.key === '6' || e.key === '7' || e.key === '8' || e.key === '9' || e.key === '0') {
        this.verCodeList[this.codeIndex].num = e.key
        this.codeIndex += 1
        if (this.codeIndex === 6) {
          let verCodeRes = ''
          for (let item of this.verCodeList) {
            verCodeRes += item.num
          }
          this.$emit('inputEnd', verCodeRes)
        }
      }
    }
    if (this.codeIndex >= 1) {
      if (e.keyCode === 8 || e.which === 8) {
        this.verCodeList[this.codeIndex - 1].num = ''
        this.codeIndex -= 1
      }
    }
  }

  private handleKeyDown(key: string) {
    if (this.codeIndex < 6) {
      this.verCodeList[this.codeIndex].num = key
      this.codeIndex += 1
      if (this.codeIndex === 6) {
        let verCodeRes = ''
        for (let item of this.verCodeList) {
          verCodeRes += item.num
        }
        this.$emit('inputEnd', verCodeRes)
      }
    }
  }
  private success() {
    this.isSuccess = true
    this.isError = false
    window.removeEventListener('keydown', this.keyDownListener)
    window.removeEventListener('focus', this.focusListener)
    window.removeEventListener('blur', this.blurListener)
  }

  private handleConfirm() {
    this.$emit('confirm')
  }

  private handleKeyDelete() {
    if (this.codeIndex >= 1) {
      this.verCodeList[this.codeIndex - 1].num = ''
      this.codeIndex -= 1
    }
  }

  private focusListener() {
    this.isShowVerificationCodeKeyboard = true
    this.codeFocus = true
  }

  private blurListener() {
    this.isShowVerificationCodeKeyboard = false
    this.codeFocus = false
  }

  private resetDefault() {
    this.verCodeList = [{ id: 1, num: '' }, { id: 2, num: '' }, { id: 3, num: '' }, { id: 4, num: '' }, { id: 5, num: '' }, { id: 6, num: '' }]
    this.codeIndex = 0
    this.isError = false
  }

  private resetError () {
    this.verCodeList = [{ id: 1, num: '' }, { id: 2, num: '' }, { id: 3, num: '' }, { id: 4, num: '' }, { id: 5, num: '' }, { id: 6, num: '' }]
    this.codeIndex = 0
    this.isError = true
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDownListener)
    window.removeEventListener('focus', this.focusListener)
    window.removeEventListener('blur', this.blurListener)
  }
}
